"use client";

import { useState } from "react";
import { NewButton } from "@/components/ui/NewButton";
import OnPremiseGuideModal from "./OnPremiseGuideModal";

export default function OnPremiseDownloadButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <NewButton
        variant="primary"
        size="lg"
        className="text-xl px-8 py-4 rounded-full"
        onClick={() => setIsModalOpen(true)}
      >
        Download For Free
      </NewButton>

      <OnPremiseGuideModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

